var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 28,
    viewBox: "0 0 65 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_200_3109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 28,
    rx: 10,
    fill: "#3B3B3C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1253 11.8V10.252H36.0173V19H34.2893V11.8H33.1253ZM37.677 14.512C37.677 13.128 37.925 12.044 38.421 11.26C38.925 10.476 39.757 10.084 40.917 10.084C42.077 10.084 42.905 10.476 43.401 11.26C43.905 12.044 44.157 13.128 44.157 14.512C44.157 15.904 43.905 16.996 43.401 17.788C42.905 18.58 42.077 18.976 40.917 18.976C39.757 18.976 38.925 18.58 38.421 17.788C37.925 16.996 37.677 15.904 37.677 14.512ZM42.501 14.512C42.501 13.92 42.461 13.424 42.381 13.024C42.309 12.616 42.157 12.284 41.925 12.028C41.701 11.772 41.365 11.644 40.917 11.644C40.469 11.644 40.129 11.772 39.897 12.028C39.673 12.284 39.521 12.616 39.441 13.024C39.369 13.424 39.333 13.92 39.333 14.512C39.333 15.12 39.369 15.632 39.441 16.048C39.513 16.456 39.665 16.788 39.897 17.044C40.129 17.292 40.469 17.416 40.917 17.416C41.365 17.416 41.705 17.292 41.937 17.044C42.169 16.788 42.321 16.456 42.393 16.048C42.465 15.632 42.501 15.12 42.501 14.512ZM49.5628 19L47.3068 16.168V19H45.6268V10.12H47.3068V15.172L49.5388 12.352H51.7228L48.7948 15.688L51.7468 19H49.5628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.307 21.9195C25.3614 21.9267 25.4159 21.9341 25.4703 21.9417L25.7438 21.9801C26.9346 22.1472 28 21.2396 28 20.058V19.1562C28 18.3112 27.4592 17.5573 26.649 17.2731C25.7129 16.9447 24.7466 16.7309 23.7711 16.6317C24.789 17.3676 25.4203 18.5593 25.4203 19.8594V20.979C25.4203 21.3042 25.3809 21.619 25.307 21.9195ZM21.1812 15.432C21.5868 15.5995 22.0324 15.6921 22.5 15.6921C24.3813 15.6921 25.9064 14.194 25.9064 12.346C25.9064 10.4981 24.3813 9 22.5 9C22.4443 9 22.3889 9.00131 22.3338 9.00391C22.6759 9.73253 22.8671 10.5461 22.8671 11.4043C22.8671 12.9808 22.2219 14.4066 21.1812 15.432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07387 21.9195C9.01942 21.9267 8.96499 21.9341 8.91058 21.9417L8.63707 21.9801C7.44625 22.1472 6.38084 21.2396 6.38084 20.058V19.1562C6.38084 18.3112 6.92166 17.5573 7.73185 17.2731C8.66791 16.9447 9.63427 16.7309 10.6098 16.6317C9.59191 17.3676 8.96057 18.5593 8.96057 19.8594V20.979C8.96057 21.3042 8.99992 21.619 9.07387 21.9195ZM13.1997 15.432C12.7941 15.5995 12.3485 15.6921 11.8808 15.6921C9.99952 15.6921 8.47442 14.194 8.47442 12.346C8.47442 10.4981 9.99952 9 11.8808 9C11.9366 9 11.992 9.00131 12.0471 9.00391C11.705 9.73253 11.5138 10.5461 11.5138 11.4043C11.5138 12.9808 12.159 14.4066 13.1997 15.432Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3671 11.4043C21.3671 9.10992 19.5071 7.25 17.2128 7.25C14.9185 7.25 13.0586 9.10992 13.0586 11.4043C13.0586 13.6986 14.9185 15.5585 17.2128 15.5585C19.5071 15.5585 21.3671 13.6986 21.3671 11.4043Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.153 17.5215C15.425 16.3529 19.0006 16.3529 22.2727 17.5215C23.2607 17.8743 23.9203 18.8103 23.9203 19.8594V20.979C23.9203 22.446 22.621 23.5729 21.1687 23.3654L20.8351 23.3178C18.4325 22.9745 15.9932 22.9745 13.5905 23.3178L13.2569 23.3654C11.8047 23.5729 10.5054 22.446 10.5054 20.979V19.8594C10.5054 18.8103 11.1649 17.8743 12.153 17.5215Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_200_3109",
    x: -200,
    y: -200,
    width: 465,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_200_3109"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_200_3109",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10K);
export default __webpack_public_path__ + "static/media/10k.2b0c782c86e658155bae2490fb3ed43e.svg";
export { ForwardRef as ReactComponent };